var _bblSite = '';
const _initialize = () => {
  if (!window.dataLayer) {
    return;
  }
  for (var i = 0; i < window.dataLayer.length; ++i) {
    if (window.dataLayer[i].hasOwnProperty('bblSite')) {
      _bblSite = window.dataLayer[i].bblSite;
    }
  }
};

/**
 * @param eventCategory should be the project name, or a big groups of events. Examples: 'Bli medlem', 'Forkjøp', 'Min side', 'Styreportal'.
 * @param eventAction should be what the user DID. Examples are Viewed receipt, Searched Forkjøp, Opened email
 * @param eventLabel is some metadata about what the user did. What did he/she search for? What email was opened? NOTE: Google Analytics does not allow personal data to be pushed into it. So label should never include name / phone number or anything else that can be used as personal information. This would violate GDPR.
 * @param extraProps will be extra variables to push to the data layer. This can be any string: string object mapping.
 */
const trackEvent = (eventCategory, eventAction, eventLabel, extraProps) => {
  if (!window.dataLayer) {
    console.log('GTM: Data layer not set. Please ensure GTM script is loaded before tracking events.');
  }
  if (!_bblSite) {
    _initialize();
    if (!_bblSite) {
      console.log('GTM: `bblSite` should be pushed to data layer before tracking ANY events.');
    }
  }
  if (!eventCategory) {
    console.log('GTM: Event category must be set!');
    return;
  }
  if (!eventAction) {
    console.log('GTM: Event action must be set!');
    return;
  }
  try {
    var e = {
      event: 'bblEvent',
      eventCategory: eventCategory,
      eventAction: eventAction,
      eventLabel: ''
    };
    if (typeof eventLabel !== 'undefined') {
      e['eventLabel'] = eventLabel;
    } else {
      e['eventLabel'] = '';
    }
    if (typeof extraProps !== 'undefined') {
      for (var property in extraProps) {
        if (extraProps.hasOwnProperty(property)) {
          e[property] = extraProps[property];
        }
      }
    }
    window['dataLayer'].push(e);
  } catch (e) {}
};
/**
 *
 * @param siteCategory should be the project site / domain. Examples: 'Bli medlem', 'Min side', 'Styreportal'.
 * @param path should be the page to track. This defaults to the path in the current URL. You can override this if you like to track a more specific page / the URL contains sensitive information.
 * @param title
 * @param extraProps
 */
const trackPageview = (siteCategory, path, title, extraProps) => {
  if (typeof path === 'undefined') {
    path = document.location.href.replace(/^.*\/\/[^\/]+/, '');
  }
  if (typeof extraProps === 'undefined' && typeof title === 'object') {
    extraProps = title;
    title = undefined;
  }
  try {
    var e = {
      event: 'bblPageview',
      eventCategory: siteCategory,
      eventAction: path,
      eventLabel: ''
    };
    if (typeof title) {
      e['eventLabel'] = title;
    }
    if (typeof extraProps !== 'undefined') {
      for (var property in extraProps) {
        if (extraProps.hasOwnProperty(property)) {
          e[property] = extraProps[property];
        }
      }
    }
    window['dataLayer'].push(e);
  } catch (e) {}
};
export { trackEvent, trackPageview };